// components/common/Select/styles.js
import styled from "styled-components";

export const SelectWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const StyledSelect = styled.select`
	width: 100%;
	padding: ${(props) => props.theme.spacing.md};
	font-size: ${(props) => props.theme.typography.sizes.md};
	color: ${(props) => props.theme.colors.text.primary};
	background-color: white;
	border: 1px solid ${(props) => props.theme.colors.text.disabled};
	border-radius: ${(props) => props.theme.borderRadius.md};
	appearance: none;
	cursor: pointer;
	transition: all ${(props) => props.theme.transitions.fast};

	&:focus {
		outline: none;
		border-color: ${(props) => props.theme.colors.primary.main};
		box-shadow: 0 0 0 2px ${(props) => props.theme.colors.primary.main}20;
	}

	&:disabled {
		background-color: ${(props) => props.theme.colors.background.alt};
		cursor: not-allowed;
	}
`;

export const SelectArrow = styled.div`
	position: absolute;
	right: ${(props) => props.theme.spacing.md};
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	color: ${(props) => props.theme.colors.text.secondary};
`;
